import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/scss/main.scss";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import Fragment from "vue-fragment";
import $ from "jquery";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Loading from "@/components/Loading.vue";
import LoadingWhite from "@/components/LoadingWhite.vue";
import VueTheMask from "vue-the-mask";
import { Steps, Step } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueFormulate from "@braid/vue-formulate";
import { pt } from "@braid/vue-formulate-i18n";
import { BootstrapVue } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(VueTheMask);
Vue.use(VueToast, {
  duration: 2600,
  dismissible: true,
  position: "bottom-right",
});
Vue.use(Fragment.Plugin);
Vue.use(Steps);
Vue.use(Step);
Vue.use(VueFormulate, {
  validationNameStrategy: ["validationName", "label", "name", "type"],
  plugins: [pt],
  locale: "pt",
});

Vue.config.productionTip = false;
Vue.component("loading", Loading);
Vue.component("loading-white", LoadingWhite);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

Vue.directive("tooltip", function (el, binding) {
  $(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: "hover",
  });
});
Vue.directive("popover", function (el, binding) {
  $(el).popover({
    content: binding.value,
    placement: binding.arg,
    trigger: "click",
    html: true,
  });
});
